import { GetAppConfig } from '../actions/app';

export default (store) => {
    store.dispatch(GetAppConfig());
};
